<template>
  <div>
    <table class="table table-xs table-hover">
      <thead>
      <tr>
        <th colspan="5" class=" text-danger">MUAF KATEGORİLER
          <el-tooltip class="item" effect="dark"
                      content="Borçlandırma esnasında Mesken Türüne göre muaf Kategoriler atayabilirsiniz."
                      placement="top">
            <i class="el-icon-info text-primary cursor-pointer"></i>
          </el-tooltip>

          <button v-if="Yetki"
                  @click="this.Ekle"
                  class="el-button TableBtn el-button--success el-button--mini float-right">YENİ MUAF KATEGORİ
          </button>
        </th>
      </tr>
      <tr>
        <th>Mesken Türü</th>
        <th>Kategori</th>
        <th width="20" v-if="Yetki"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="Muaf in Liste">
        <td>{{Muaf.MeskenTuruText}}</td>
        <td>{{Muaf.KategoriText}}</td>
        <td v-if="Yetki">
          <el-tooltip class="item" effect="dark"
                      :content="Sayfa.SilAdi"
                      placement="top-start">
            <a href="#" @click="SilOnay(Muaf.id)" class="text-danger"> <i
              class="el-icon-delete-solid"></i></a>
          </el-tooltip>


        </td>
      </tr>
      </tbody>

    </table>

    <el-form v-if="Form.Form" class="BilgiForm" :rules="FormHata" :model="Form"
             @submit.prevent.native="MeskenTuruKaydet"
             ref="MeskenTuru">
      <h2>{{Form.Baslik}} <a @click="Form=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      </h2>

      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Kategori" prop="Kategori_id">
            <el-cascader
              size="mini"
              :props="{ multiple: true}"
              :options="KategoriSelect"
              v-model="Form.Kategori_id"
              collapse-tags
              filterable></el-cascader>

          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Mesken Türü" prop="Mesken_Turu_id">
            <el-select v-model="Form.Mesken_Turu_id" size="mini" filterable>
              <el-option
                v-for="item in MeskenTurleri"
                :key="item.id"
                :label="item.Tanim"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>


        </el-col>
      </el-row>


      <button type="button" @click="MeskenTuruKaydet"
              class="el-button mt-2 YeniBtn el-button--success el-button--mini btn-block">KAYDET
      </button>

    </el-form>
  </div>
</template>


<script>
  export default {
    props: {
      BinaBilgi: Object
    },
    data() {
      return {
        Sayfa: {
          ButtonAdi: this.$t('eGenel.10'),
          DuzenleAdi: this.$t('eGenel.10'),
          SilAdi: this.$t('eGenel.11'),
          Button: null,
          Adi: this.$t('eYonetim.20.0'),
          Menu: [],
          MenuDisplay: null,
        },
        Yetki: false,
        Liste: [],
        KategoriSelect: [],
        MeskenTurleri: [],
        Form: {
          Baslik: 'Muaf Kategori Ekle',
          id: null,
          Form: false,
          Mesken_Turu_id: null,
          Bina_id: this.BinaBilgi.id,
          Kategori_id: null,
        },
        FormHata: {
          Mesken_Turu_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Kategori_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        }

      }
    },
    methods: {
      MeskenTuruKaydet() {
        this.$refs['MeskenTuru'].validate((valid) => {
            if (valid) {

              // EKLE
              this.$store.dispatch("Post", {
                ...this.Form,
                path: 'yonetim/bina/muaf/' + this.BinaBilgi.id
              })
                .then(response => {
                  if (response.Durum == "OK") {
                    this.SayfaYukle();
                    this.$message.success(response.Mesaj);
                    this.Form = {
                      Baslik: 'MeskenTuru Ekle',
                      id: null,
                      Form: false,
                      Mesken_Turu_id: null,
                      Bina_id: this.BinaBilgi.id,
                      Kategori_id: null
                    }
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })

            }
          }
        );
      },
      SayfaYukle() {
        if (this.BinaBilgi.id) {
          this.$store.dispatch("Get", {path: 'yonetim/bina/muaf/' + this.BinaBilgi.id})
            .then(response => {
              if (response.Durum === 'OK') {
                this.Liste = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });
          this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
            .then(response => {
              if (response.Durum === 'OK') {
                this.KategoriSelect = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });
          this.$store.dispatch("Get", {path: 'yonetim/sirket/meskenturu'})
            .then(response => {
              if (response.Durum === 'OK') {
                this.MeskenTurleri = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });
        }

        this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
      },
      Ekle() {
        this.Form = {
          Baslik: 'Muaf Kategori Ekle',
          id: null,
          Form: true,
          Mesken_Turu_id: null,
          Kategori_id: null,
          Bina_id: this.BinaBilgi.id
        }
      },

      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/bina/muaf/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },

    },
    created() {
      this.SayfaYukle()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Comp/MeskenTuru.vue